import React from 'react';
import { Card, Space, Tag, Typography, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../Shared/GlobalContext/ThemeContext';
import { formatFullTime } from '../../../../utils/messageRenderUtils';
import { useNavigate } from 'react-router-dom';
import { EyeOutlined } from '@ant-design/icons';

const { Text } = Typography;

const STATUS_COLORS = {
    open: 'blue',
    in_progress: 'orange',
    resolved: 'green',
    closed: 'default',
};

const PRIORITY_COLORS = {
    low: 'default',
    medium: 'blue',
    high: 'orange',
    urgent: 'red',
};

const CATEGORY_COLORS = {
    escalation: 'volcano',
    reclamation: 'magenta',
    suggestion: 'cyan',
    order: 'geekblue',
    other: 'default',
};

const MessageTicketInfo = ({ ticket }) => {
    const { t } = useTranslation();
    const { isDarkMode } = useTheme();
    const navigate = useNavigate();

    if (!ticket) return null;

    const themeColors = {
        cardBackground: isDarkMode ? '#1f1f1f' : '#fff',
        text: isDarkMode ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.88)',
        secondaryText: isDarkMode ? 'rgba(255, 255, 255, 0.65)' : 'rgba(0, 0, 0, 0.45)',
    };

    return (
        <Card
            title={t('ticket_details')}
            style={{ background: themeColors.cardBackground }}
            extra={
                ticket.id && (
                    <Button
                        type="link"
                        icon={<EyeOutlined />}
                        size="small"
                        onClick={() => navigate(`/tickets/${ticket.id}`)}
                    >
                        {t('view_ticket')}
                    </Button>
                )
            }
        >
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                {ticket.subject && (
                    <div>
                        <Text strong style={{ color: themeColors.text }}>{t('ticket_subject')}:</Text>
                        <Text style={{ color: themeColors.text, marginInlineStart: 8 }}>{ticket.subject}</Text>
                    </div>
                )}

                <Space wrap>
                    {ticket.category && (
                        <Tag color={CATEGORY_COLORS[ticket.category] || 'default'}>
                            {t(`ticket_category_${ticket.category}`) || ticket.category}
                        </Tag>
                    )}
                    {ticket.priority && (
                        <Tag color={PRIORITY_COLORS[ticket.priority] || 'default'}>
                            {t(`ticket_priority_${ticket.priority}`) || ticket.priority}
                        </Tag>
                    )}
                    {ticket.status && (
                        <Tag color={STATUS_COLORS[ticket.status] || 'default'}>
                            {t(`ticket_status_${ticket.status}`) || ticket.status}
                        </Tag>
                    )}
                </Space>

                {ticket.resolved_at && (
                    <Text style={{ color: themeColors.text }}>
                        {t('resolved_at')}: {formatFullTime(ticket.resolved_at)}
                    </Text>
                )}

                {ticket.resolved_by && (
                    <Text style={{ color: themeColors.text }}>
                        {t('resolved_by')}: {ticket.resolved_by.full_name}
                    </Text>
                )}

                {ticket.created_at && (
                    <Text type="secondary" style={{ color: themeColors.secondaryText }}>
                        {t('created_at')}: {formatFullTime(ticket.created_at)}
                    </Text>
                )}
            </Space>
        </Card>
    );
};

export default MessageTicketInfo;
